// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import axios from 'axios'
import VueAxios from 'vue-axios'

import * as echarts from 'echarts'

// Vue.config.productionTip = false
axios.defaults.baseURL = global.ymtApi
Vue.use(ElementUI).use(VueAxios,axios).use(echarts)
Vue.prototype.$axios = axios

import global from './utils/global'
Vue.prototype.$global = global

//公共方法
import common from './utils/common'
Vue.prototype.$common = common

import signalr from './utils/signalR'
Vue.use(signalr)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js